const STORAGE_KEY = 'invite_ref'

/** 启动时读取 URL ?ref= 参数存入 localStorage，并清除 URL 参数 */
export function captureInviteRef(): void {
  const params = new URLSearchParams(window.location.search)
  const ref = params.get('ref')
  if (ref) {
    localStorage.setItem(STORAGE_KEY, ref)
    params.delete('ref')
    const newUrl = params.toString()
      ? `${window.location.pathname}?${params.toString()}`
      : window.location.pathname
    window.history.replaceState({}, '', newUrl)
  }
}

/** 获取缓存的邀请码 */
export function getInviteRef(): string | null {
  return localStorage.getItem(STORAGE_KEY)
}

/** 绑定成功后清除邀请码 */
export function clearInviteRef(): void {
  localStorage.removeItem(STORAGE_KEY)
}
